import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { monitorSessionActivity } from "../lib/session-activity";

export function SessionIdleWarning({ seconds, onStaySignedIn, error = "" }: { seconds: number; onStaySignedIn: () => void; error?: string }) {
  return <section className="session-idle-warning" aria-label="Automatische Abmeldung">
    <div>
      <strong role="alert">Du wirst gleich abgemeldet.</strong>
      <p>Ohne weitere Eingabe wirst du in <span role="timer" aria-live="off">{seconds}</span> Sekunden abgemeldet. Nicht gespeicherte Eingaben können verloren gehen.</p>
      {error && <p role="status">{error}</p>}
    </div>
    <button className="primary" type="button" onClick={onStaySignedIn}>Angemeldet bleiben</button>
  </section>;
}

export function SessionActivity({ accountId, onExpired }: { accountId: string; onExpired: () => void }) {
  const [seconds, setSeconds] = useState<number | null>(null);
  const [error, setError] = useState("");
  const expired = useRef(onExpired);
  expired.current = onExpired;
  const monitor = useRef<ReturnType<typeof monitorSessionActivity> | null>(null);

  useEffect(() => {
    monitor.current = monitorSessionActivity(accountId, {
      warning: setSeconds, error: setError,
      expired: () => expired.current(),
      changed: () => window.location.reload(),
    });
    return () => { monitor.current?.stop(); monitor.current = null; };
  }, [accountId]);

  if (seconds === null) return null;
  const warning = <SessionIdleWarning seconds={seconds} error={error} onStaySignedIn={() => monitor.current?.staySignedIn()} />;
  const pauseDialog = document.querySelector(".exercise-pause-modal .exercise-pause-warning-host") ?? document.querySelector(".reflection-panel .exercise-pause-warning-host");
  return pauseDialog ? createPortal(warning, pauseDialog) : warning;
}
